export default {
    fields: {
        email: 'Email',
        password: 'Password',
        confirm_password: 'Confirm Password',
        message: 'Message',
        send: 'Send',
        firstName: 'First Name',
        lastName: 'Last Name',
        phone: 'Phone (optional)',
        cellPhone: 'Cell phone (optional)',
        confirmPassword: 'Confirm Password',
        save: 'Save',
        cardNumber: 'Cleandataset API Key',  // This is misnamed.
        cardExpDate: 'Exp date',
        deleteCard: 'Delete Card',
        addCard: 'Add Card',
        name: 'Name',
        tt_secret: 'API Secret',
        key: 'Key',
        session_name: 'Session Name',
        target_name: 'Target Name',
        user_name: 'User Name',
    },
};
